// Konfiguracja statusow faktur
export const statusConfig = {
  nowa: { bg: 'var(--info-light)', text: 'var(--info)', label: 'Nowa' },
  oczekujaca: { bg: 'var(--warning-light)', text: 'var(--warning)', label: 'Oczekujaca' },
  weryfikacja: { bg: 'var(--purple-light)', text: 'var(--purple)', label: 'Weryfikacja' },
  zatwierdzona: { bg: 'var(--success-light)', text: 'var(--success)', label: 'Zatwierdzona' },
  odrzucona: { bg: 'var(--danger-light)', text: 'var(--danger)', label: 'Odrzucona' }
};

// Konfiguracja typow platnosci
export const paymentTypeConfig = {
  gotowka: { icon: '💵', label: 'Gotówka', color: 'var(--success)' },
  przelew: { icon: '🏦', label: 'Przelew', color: 'var(--info)' },
  karta: { icon: '💳', label: 'Karta', color: 'var(--purple)' },
  blik: { icon: '📱', label: 'BLIK', color: 'var(--danger)' }
};

// Konfiguracja zakladek
export const tabsConfig = [
  { id: 'overview', label: 'Przegląd', icon: '📊' },
  { id: 'invoices', label: 'Faktury handlowe', icon: '📄' },
  { id: 'payments', label: 'Płatności', icon: '💰' },
  { id: 'cash-flow', label: 'Przepływy', icon: '📈' },
  { id: 'costs', label: 'Koszty zewnętrzne', icon: '💸' },
  { id: 'koszty-ksef', label: 'Koszty z KSeF', icon: '🧾' },
  { id: 'profitability', label: 'Rentowność', icon: '📉' },
  { id: 'wydatki', label: 'Wydatki', icon: '🧾' },
  { id: 'card-validation', label: 'Walidacja kart', icon: '💳' }
];

// Format kwoty
export const formatMoney = (value) => {
  return new Intl.NumberFormat('pl-PL', {
    style: 'currency',
    currency: 'PLN'
  }).format(value || 0);
};

// Format daty
export const formatDate = (dateString) => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString('pl-PL');
};

// Sprawdz czy faktura jest przeterminowana
export const isOverdue = (invoice) => {
  if (invoice.status === 'zatwierdzona') return false;
  const dueDate = invoice.data_platnosci ? new Date(invoice.data_platnosci) : null;
  return dueDate && dueDate < new Date();
};

// Dni do terminu platnosci
export const getDaysUntilDue = (dateString) => {
  if (!dateString) return null;
  const dueDate = new Date(dateString);
  const today = new Date();
  const diff = Math.ceil((dueDate - today) / (1000 * 60 * 60 * 24));
  return diff;
};
